import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { BodyLargeRegular, BodyMediumRegular, Highlight, TitleLarge } from "../../../components/font";
import { Button } from "@manifesthhqinc/ui-library";
import Footer from "../../../components/footer";

import { UseHenryQuestionniareProps } from "../useHenryQuestionnaire";
import { HenryAvatorDiv, HenryIntroCard, HenryIntroContainer } from "./styles";
import HenryAvator from "../../../components/henry/HenryAvator";
import Spacing from "../../../layout/spacing";

const HenryIntroScreen = (props: UseHenryQuestionniareProps) => {
  const { onClickStart, userDetails } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-intro-screen">
        <Container fullHeight>
          <HenryIntroContainer>
            <HenryAvatorDiv>
              <HenryAvator />
            </HenryAvatorDiv>
            <HenryIntroCard>
              <TitleLarge>Hi {userDetails.firstName || ""}, I'm Henry!</TitleLarge>
              <BodyMediumRegular>
                <Highlight>Transfer Specialist</Highlight>
              </BodyMediumRegular>
              <Spacing vertical="16" />
              <BodyLargeRegular $textAlign="center">
                I've got a few short questions to help find the best destination option for you.
              </BodyLargeRegular>
            </HenryIntroCard>
          </HenryIntroContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={onClickStart} size="large" name="startHenryQuestionnaire">
          Let's begin
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default HenryIntroScreen;
